module.exports = __webpack_public_path__ + "static/media/headerImg.b1b2edf8.png";